import { Network } from '@capacitor/network';
import { platform } from './identity';

export function normalizeNetworkStatus(status = {}) {
  return Object.freeze({ connected: status.connected !== false, connectionType: status.connectionType || 'unknown' });
}

export function createNetworkController({ native = platform.isNative, network = Network, win = typeof window !== 'undefined' ? window : undefined } = {}) {
  let state = normalizeNetworkStatus({ connected: win?.navigator?.onLine !== false, connectionType: 'unknown' });
  const listeners = new Set();
  let cleanup = null;
  const publish = (next) => { state = normalizeNetworkStatus(next); listeners.forEach((listener) => listener(state)); };
  const start = () => {
    if (cleanup) return;
    if (native) {
      let handle;
      let cancelled = false;
      network.getStatus().then(publish).catch(() => {});
      Promise.resolve(network.addListener('networkStatusChange', publish)).then((value) => { if (cancelled) value?.remove?.(); else handle = value; });
      cleanup = () => { cancelled = true; handle?.remove?.(); };
    } else {
      const online = () => publish({ connected: true, connectionType: 'unknown' });
      const offline = () => publish({ connected: false, connectionType: 'none' });
      win?.addEventListener?.('online', online); win?.addEventListener?.('offline', offline);
      cleanup = () => { win?.removeEventListener?.('online', online); win?.removeEventListener?.('offline', offline); };
    }
  };
  const refresh = async () => {
    if (native) return normalizeNetworkStatus(await network.getStatus());
    return normalizeNetworkStatus({ connected: win?.navigator?.onLine !== false, connectionType: 'unknown' });
  };
  return {
    getState: () => state,
    refresh,
    subscribe(listener) {
      listeners.add(listener);
      start();
      return () => { listeners.delete(listener); if (!listeners.size && cleanup) { cleanup(); cleanup = null; } };
    },
  };
}

export const network = createNetworkController();
